module.exports = __webpack_public_path__ + "img/thumb_Atelier_9.3a41f941.jpg";